import styled from 'styled-components/macro'

export const GraphsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 30px;
`
